export const blockIconsAudioandvideoVideocamNew = (
	<span className='material-symbols-outlined'>videocam</span>
);
